import firebase from "firebase/app"
import { backendUrl } from "../utils/variables"

const getCurrentToken = async (forceRefresh = false) => {
  const user = firebase.auth().currentUser

  if (!user) {
    throw new Error("No hay una sesión activa de Firebase")
  }

  return user.getIdToken(forceRefresh)
}

const getHeaders = (token) => ({
  "Content-Type": "application/json",
  Accept: "application/json",
  Authorization: `Bearer ${token}`
})

const getHeadersWhitOutToken = () => ({
  "Content-Type": "application/json",
  Accept: "application/json"
})

// ?variable=valor
class Servo {
  async request(url, options = {}, wt = true) {
    const execute = async (forceRefresh = false) =>
      fetch(backendUrl + url, {
        ...options,
        headers: wt
          ? getHeaders(await getCurrentToken(forceRefresh))
          : getHeadersWhitOutToken()
      })

    let res = await execute()

    // Firebase puede conservar un ID token vencido. Si el backend lo rechaza,
    // se renueva y se repite la petición una sola vez.
    if (wt && res.status === 401) {
      res = await execute(true)
    }

    return res
  }

  async get(url, wt = true, options = {}) {
    const res = await this.request(url, { ...options, method: "GET" }, wt)
    return res.json()
  }

  async post(
    url,
    body,
    redirectURL,
    redirectOnSave = true,
    history,
    wt = true
  ) {
    const res = await this.request(url, {
      method: "POST",
      body: JSON.stringify(body)
    }, wt)
    let resJson = await res.json()
    if (resJson?.cuerpo?.detalle?.estatus == 200) {
      if (redirectOnSave) {
        history.push("/" + redirectURL)
      }
    } else {
    }
    return resJson
  }

  async update(url, body, wt = true) {
    const res = await this.request(url, {
      method: "PUT",
      body: JSON.stringify(body)
    }, wt)
    return res.json()
  }

  async delete(url, body, wt = true) {
    const res = await this.request(url, {
      method: "DELETE",
      body: JSON.stringify(body)
    }, wt)
    return res.json()
  }
}

export default new Servo()
